module.exports = __webpack_public_path__ + "./img/callback.6aa8592f925c039872cc538c341f8cd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Briefcase/entry/icons/callback.png
// module id = ./src/containers/Briefcase/entry/icons/callback.png
// module chunks = 0